import type { FC } from 'react';
import { FeatureIndicatorIcon } from '@components/FeatureIndicatorIcon';
import { mdiAlert, mdiBell } from '@mdi/js';
import { getBlockExpiryDateTooltip } from '@root/helpers/blocks';
import { isEmpty } from 'lodash-es';

interface BlockExpiryDateIndicatorProps {
  inceptionDate?: string | null;
  expiryDate?: string | null;
  isBlock: boolean;
}

export const BlockExpiryDateIndicator: FC<BlockExpiryDateIndicatorProps> = ({ expiryDate, isBlock, inceptionDate }) => {
  if (!expiryDate && !inceptionDate) return null;

  const { isInactive, tooltip } = getBlockExpiryDateTooltip(
    inceptionDate ?? undefined,
    expiryDate ?? undefined,
    isBlock,
  );

  if (isEmpty(tooltip)) {
    return null;
  }

  return (
    <FeatureIndicatorIcon
      placement="top"
      path={isInactive ? mdiAlert : mdiBell}
      content={tooltip}
      className={isInactive ? 'text-error-900' : ''}
      data-testid="block-icon-indicator:expiry-date"
    />
  );
};
